/**
 * @generated SignedSource<<bbbb4577f467c6dc7ae2b20ad66e94b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type featureTogglesScreen_Refetch$variables = {
  after?: string | null;
  first?: number | null;
};
export type featureTogglesScreen_Refetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"featureTogglesScreen_QueryFragment">;
};
export type featureTogglesScreen_Refetch = {
  response: featureTogglesScreen_Refetch$data;
  variables: featureTogglesScreen_Refetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isActive",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "featureTogglesScreen_Refetch",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "featureTogglesScreen_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "featureTogglesScreen_Refetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureToggleAdminSchema",
            "kind": "LinkedField",
            "name": "FeatureToggle",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "FeatureTogglesConnection",
                "kind": "LinkedField",
                "name": "featureToggles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeatureTogglesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeatureToggle",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "kind",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v3/*: any*/),
                                "type": "TimeBasedLicensesFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v3/*: any*/),
                                "type": "SplitCourseCertificationFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v3/*: any*/),
                                "type": "AbandonedCartReminderFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v3/*: any*/),
                                "type": "ExperimentalModeFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v3/*: any*/),
                                "type": "CourseRecommendationsFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v3/*: any*/),
                                "type": "ScheduledGlobalDiscountFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v3/*: any*/),
                                "type": "SecciDownloadCheckoutFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v3/*: any*/),
                                "type": "SignupMarketingOptInFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v3/*: any*/),
                                "type": "InProductExpressCheckoutFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v3/*: any*/),
                                "type": "ProfileEnrichmentSetNameFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v3/*: any*/),
                                "type": "StoryblokCampaignsFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v3/*: any*/),
                                "type": "PaymentProviderInvoiceNoticeFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v3/*: any*/),
                                "type": "NoConsentOrderAttributionFeatureToggleData",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "featureTogglesScreen_QueryFragment__featureToggles",
                "kind": "LinkedHandle",
                "name": "featureToggles"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0fba5a0bf4a77cf7d37abb444793913b",
    "id": null,
    "metadata": {},
    "name": "featureTogglesScreen_Refetch",
    "operationKind": "query",
    "text": "query featureTogglesScreen_Refetch(\n  $after: String\n  $first: Int\n) {\n  ...featureTogglesScreen_QueryFragment_2HEEH6\n}\n\nfragment featureTogglesScreen_FeatureToggleFragment on FeatureToggle {\n  id\n  data {\n    __typename\n    kind\n    ... on TimeBasedLicensesFeatureToggleData {\n      name\n      isActive\n    }\n    ... on SplitCourseCertificationFeatureToggleData {\n      name\n      isActive\n    }\n    ... on AbandonedCartReminderFeatureToggleData {\n      name\n      isActive\n      kind\n    }\n    ... on ExperimentalModeFeatureToggleData {\n      name\n      isActive\n    }\n    ... on CourseRecommendationsFeatureToggleData {\n      name\n      isActive\n    }\n    ... on ScheduledGlobalDiscountFeatureToggleData {\n      name\n      isActive\n    }\n    ... on SecciDownloadCheckoutFeatureToggleData {\n      name\n      isActive\n    }\n    ... on SignupMarketingOptInFeatureToggleData {\n      name\n      isActive\n    }\n    ... on InProductExpressCheckoutFeatureToggleData {\n      name\n      isActive\n    }\n    ... on ProfileEnrichmentSetNameFeatureToggleData {\n      name\n      isActive\n    }\n    ... on StoryblokCampaignsFeatureToggleData {\n      name\n      isActive\n    }\n    ... on PaymentProviderInvoiceNoticeFeatureToggleData {\n      name\n      isActive\n    }\n    ... on NoConsentOrderAttributionFeatureToggleData {\n      name\n      isActive\n    }\n  }\n  __typename\n}\n\nfragment featureTogglesScreen_QueryFragment_2HEEH6 on Query {\n  Admin {\n    FeatureToggle {\n      featureToggles(first: $first, after: $after) {\n        pageInfo {\n          endCursor\n          hasPreviousPage\n          hasNextPage\n          startCursor\n        }\n        edges {\n          node {\n            ...featureTogglesScreen_FeatureToggleFragment\n            id\n            __typename\n          }\n          cursor\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e2c4c56f31712083412d849937e23e7";

export default node;
